import React from 'react';
import ReactDOM from 'react-dom';
// import {AppContainer} from 'react-hot-loader';
import 'es6-symbol/implement';
import 'es6-promise/auto';
// Styles
import 'availity-uikit/scss/_bootstrap.scss';
import './index.scss';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './Common/interceptor/interceptor-api';
import App from './App';

require('isomorphic-fetch');

ReactDOM.render(<App />, document.getElementById('root'));
